import { FccAdAlertType } from '@backoffice-frontend/graphql'
import { useTheme } from '@backoffice-frontend/patterns'
import { PhoneCallIcon } from '@moia-dev/pace-icons'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useSound from 'use-sound'
import { CallControlButton } from './CallControlButton'

export const RingingButton = ({
  pickup,
  isRinging,
  alertType,
}: {
  pickup: VoidFunction
  isRinging: boolean
  alertType: FccAdAlertType
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  // Play sound for incoming passenger calls
  const [isPlayingIncomingCallSound, setIsPlayingIncomingCallSound] =
    useState(false)
  const [play, { stop }] = useSound('/assets/sounds/incoming-call.mp3', {
    volume: 1,
    loop: true,
    soundEnabled: isPlayingIncomingCallSound,
  })

  useEffect(() => {
    if (isRinging) {
      setIsPlayingIncomingCallSound(true)
    } else {
      setIsPlayingIncomingCallSound(false)
    }
  }, [isRinging])

  useEffect(() => {
    if (isPlayingIncomingCallSound) {
      play()
    } else {
      stop()
    }
  }, [isPlayingIncomingCallSound, play, stop])

  useEffect(() => {
    return () => {
      stop()
    }
  }, [stop])

  if (!isRinging) {
    return null
  }

  return (
    <>
      <CallControlButton
        onClick={pickup}
        icon={
          <PhoneCallIcon
            css={{
              color: theme.semantic.ColorBackgroundAlternative,
            }}
          />
        }
        backgroundColor={theme.semantic.ColorSuccessDefault}
      />
      {alertType === FccAdAlertType.IncomingSafetyDriverCall
        ? t('adFleetMap_callStatus_incomingSafetyDriverCall_message')
        : t('adFleetMap_callStatus_incomingPassengerCall_message')}
    </>
  )
}
